import { mapMutations } from "vuex"
import { getFormulaire } from "@/plugins/services/formulaires"

export default {
  data() {
    return {
      loading: true,
      paramsFormulaire: null,
      idFormulaire: null
    }
  },
  methods: {
    ...mapMutations(["SET_CHAMPS", "SET_RESSOURCES", "SET_CATALOGUES"]),
    async loadParams(id) {
      this.loading = true
      try {
        let res = await getFormulaire(id)
        let paramsFormulaire = res.data

        if (paramsFormulaire.champs && paramsFormulaire.champs.length > 0) {
          this.SET_CHAMPS(paramsFormulaire.champs)
        }
        if (paramsFormulaire.ressources && paramsFormulaire.ressources.length > 0) {
          this.SET_RESSOURCES(paramsFormulaire.ressources)
        }
        if (paramsFormulaire.catalogues && paramsFormulaire.catalogues.length > 0) {
          this.SET_CATALOGUES(paramsFormulaire.catalogues)
        }

        this.paramsFormulaire = paramsFormulaire
      } catch (err) {
        this.$router.push({ path: "/param-formulaire-introuvable/" + id })
      }
      this.loading = false
    }
  }
}

